module.exports = __webpack_public_path__ + "static/media/app_screens_1.6c68d6fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/app_screens_1.png
// module id = 366
// module chunks = 0